__webpack_require__.p = "https://portal-skoolas.shaktavisi.com/";